export default {
    tabs: [],
    activeTab: null,
    useTabsNavigation: localStorage.getItem('useTabsNavigation') === 'true'
}